import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import styles from './styles/LoginPage.module.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const LoginPage: React.FC = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');

        try {
            const response = await fetch(`${API_URL}/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username, password }),
            });

            const data = await response.json();

            if (response.ok) {
                // local_ids es la fuente de verdad; default_local_id queda
                // como respaldo para backends aun no actualizados.
                const localIds: number[] = Array.isArray(data.local_ids)
                    ? data.local_ids
                    : (data.default_local_id != null ? [data.default_local_id] : []);
                login({
                    token: data.token,
                    username: data.username,
                    localIds,
                    rol: data.rol,
                });
                navigate('/admin');
            } else {
                setError(data.message || 'Error al iniciar sesión');
            }
        } catch (err) {
            setError('Error de conexión con el servidor');
        }
    };

    return (
        <div className={styles['login-container']}>
            <div className={styles['login-card']}>
                <h2>Bienvenido</h2>
                <p>Ingresa tus credenciales para acceder al panel.</p>
                {error && <div className={styles['error-message']}>{error}</div>}
                <form onSubmit={handleSubmit}>
                    <div className={styles['form-group']}>
                        <label htmlFor="username">Usuario</label>
                        <input
                            type="text"
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>
                    <div className={styles['form-group']}>
                        <label htmlFor="password">Contraseña</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className={styles['login-btn']}>
                        Ingresar
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;
